// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"100":"61f8d809","203":"1c92b3e2"}[chunkId] + ".chunk.css";
};